export const getSocketQueryParams = () => {
  if (typeof window === 'undefined') {
    return {}
  }

  const searchParams = new URLSearchParams(window.location.search)
  const operatorId = searchParams.get('operator')
  const gameId = searchParams.get('gameId')

  const query = {}
  if (operatorId) {
    query.operatorId = operatorId
  }
  if (gameId) {
    query.gameId = gameId
  }

  return query
}
